export default "__VITE_ASSET__Vl8$LBUL__"